import React from 'react';
import { Handshake } from 'lucide-react';
import AdminCRUD from '../../components/admin/AdminCRUD';

const STATUS = { active:'bg-emerald-100 text-emerald-700', inactive:'bg-red-100 text-red-700', pending:'bg-amber-100 text-amber-700' };

export default function AdminPartners() {
  return (
    <AdminCRUD
      endpoint="partners"
      title="Partners"
      icon={Handshake}
      columns={[
        { key:'organizationName', label:'Organization', render:(v,item) => (
          <div>
            <div className="font-semibold text-gray-900">{v || item.name || '—'}</div>
            <div className="text-xs text-gray-400">{item.contactPerson}</div>
          </div>
        )},
        { key:'email', label:'Email', render: v => <span className="text-sm text-gray-600">{v}</span> },
        { key:'orgType', label:'Type', render: v => v ? <span className="text-xs text-gray-500">{v}</span> : '—' },
        { key:'status', label:'Status', render: v => <span className={`px-2.5 py-0.5 rounded-full text-xs font-semibold capitalize ${STATUS[v] || 'bg-gray-100 text-gray-600'}`}>{v}</span> },
        { key:'isFeatured', label:'Featured', render: v => v ? <span className="text-gold-500">★</span> : '—' },
        { key:'createdAt', label:'Date', render: v => <span className="text-xs text-gray-400">{new Date(v).toLocaleDateString('en-NG')}</span> },
      ]}
      defaultForm={{ organizationName:'', contactPerson:'', email:'', phone:'', website:'', orgType:'', location:'', description:'', status:'pending', isFeatured:false }}
      formFields={[
        { key:'organizationName', label:'Organization Name', required:true },
        { key:'contactPerson', label:'Contact Person', required:true },
        { key:'email', label:'Email', type:'email', required:true },
        { key:'phone', label:'Phone' },
        { key:'website', label:'Website', type:'url' },
        { key:'orgType', label:'Organization Type', type:'select', options:['NGO / Non-Profit','Corporate / Business','Government Agency','Academic / Research','Faith-based Organization','International Organization','Other'] },
        { key:'location', label:'Location / Country' },
        { key:'status', label:'Status', type:'select', options:['pending','active','inactive'] },
        { key:'logo', label:'Logo', type:'image', fullWidth:true },
        { key:'description', label:'Description', type:'textarea', fullWidth:true },
        { key:'isFeatured', label:'Featured', type:'checkbox', checkLabel:'Show on homepage', fullWidth:true },
      ]}
    />
  );
}
